import { createReducer, on } from '@ngrx/store';
import { setLanguage } from '../actions/language.actions';
import { ILanguageState, ILangCode } from '../../shared/models/language.model';

const getInitialLanguage = (): ILangCode => {
  const savedLang = localStorage.getItem('lang');
  return (savedLang === 'en' || savedLang === 'ar') ? savedLang : 'en';
};

export const initialState: ILanguageState = {
  currentLanguage: getInitialLanguage()
};

export const languageReducer = createReducer(
  initialState,
  on(setLanguage, (state, { language }) => ({
    ...state,
    currentLanguage: language
  }))
);
